import React from "react";
import DonateImg from "../../Images/Donate/donate-img.png";
import { LiaHandsHelpingSolid } from "react-icons/lia";

const HomeBanner = () => {
  return (
    <div className="relative text-white h-48 md:h-[30rem] lg:h-[35rem]">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center brightness-75"
        style={{ backgroundImage: `url(${DonateImg})` }}
      ></div>

      {/* Text Overlay */}
      <div className="relative z-10 flex items-center justify-end h-full px-6 md:px-12">
        <div className="pl-6 md:pl-12 lg:pl-0  w-1/2 lg:w-2/5 ">
          <h2 className="text-lg  md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-wide drop-shadow-lg text-white md:space-y-2 animate-fadeIn">
            <span className="block text-ndlogoBlue">Give a</span>
            <span className="flex text-base xxs:p-2 items-center md:text-4xl  lg:text-6xl md:gap-2 text-white bg-ndlogoBlue/50  md:px-3 md:py-2 rounded-lg shadow-md">
              helping hand{" "}
            </span>

            <span className="block text-ndlogoBlue md:mt-2">
              to those who need it!
            </span>
          </h2>

          <p className=" hidden md:flex mt-4 text-base md:text-xl font-medium text-gray-100 animate-fadeIn delay-300">
            Together, we can make a difference in the lives of those who need it
            the most.
          </p>
          <button className="text-sm md:text-base md:mt-6 xxs:mt-3 xxs:px-2 xxs:py-2 mt-2 px-1 py-1 md:px-6 md:py-3 bg-white text-ndlogoBlue font-semibold rounded-full shadow-lg hover:bg-ndlogoBlue hover:text-white transition-all duration-300 animate-fadeIn delay-500">
            Get Started{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
